import { useState } from "react";
import { cn } from "@/lib/utils";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "./app-sidebar";
import { Header, type Crumb } from "./header";

type AppShellProps = {
  crumbs: Crumb[]
  children: React.ReactNode
  /**
   * Nội dung chiếm đúng phần còn lại của màn hình, không cuộn trang
   * (dùng cho trang có map full-height như Compare).
   */
  fixed?: boolean
};

function readSidebarCookie() {
  return !document.cookie.split("; ").includes("sidebar_state=false");
}

/**
 * Khung trang VM Console: sidebar + header sticky + vùng nội dung `px-4 py-6`.
 * `body` giữ `overflow: hidden` của editor, nên vùng inset tự cuộn.
 */
export function AppShell({ crumbs, children, fixed }: AppShellProps) {
  const [scrolled, setScrolled] = useState(false);

  return (
    <SidebarProvider defaultOpen={readSidebarCookie()} className="tw-root">
      <AppSidebar />
      <SidebarInset
        className={cn("h-svh", fixed ? "overflow-hidden" : "overflow-y-auto [scrollbar-gutter:stable]")}
        onScroll={(e) => setScrolled(e.currentTarget.scrollTop > 10)}
      >
        <Header crumbs={crumbs} scrolled={scrolled} />
        <main
          id="content"
          className={cn(
            "px-4 py-6",
            fixed && "flex min-h-0 grow flex-col overflow-hidden"
          )}
        >
          {children}
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
